import { SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

export type CampaignSearchProps = {
    value: string
    onChange: (value: string) => void
}

// A quiet title search for the campaigns header. Keeps a local value for
// responsive typing and debounces the URL update so we don't navigate on
// every keystroke.
export function CampaignSearch({ value, onChange }: CampaignSearchProps) {
    const { t } = useTranslation()
    const [local, setLocal] = useState(value)
    const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

    // Keep in sync when the filter is changed or cleared from outside.
    useEffect(() => {
        setLocal(value)
    }, [value])

    useEffect(() => () => clearTimeout(timer.current), [])

    const handle = (next: string) => {
        setLocal(next)

        if (timer.current) {
            clearTimeout(timer.current)
        }

        timer.current = setTimeout(() => onChange(next), 300)
    }

    return (
        <Input
            allowClear
            size="large"
            value={local}
            prefix={<SearchOutlined className="text-ink-tertiary" />}
            placeholder={t('Search campaigns')}
            onChange={(event) => handle(event.target.value)}
            className="w-full sm:w-[220px]"
        />
    )
}
